// extracted by mini-css-extract-plugin
module.exports = {"form":"DoctorManagement_form__YI4Rk"};